import React from 'react';
import { MdOutlineChevronLeft } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

/**
 * BackButton
 * Props:
 * - onBeforeNavigate?: async function to run before navigating back
 * - to?: optional path to navigate to (defaults to navigate(-1))
 * - disabled?: boolean to disable the button
 * - className?: extra classes
 * - label?: custom text label (default: "Back")
 * - icon?: custom React node shown before label (default: left chevron)
 */
function BackButton({ onBeforeNavigate, to, disabled, className, label, icon }) {
  const navigate = useNavigate();

  const handleClick = async () => {
    if (disabled) return;
    try {
      if (typeof onBeforeNavigate === 'function') {
        await onBeforeNavigate();
      }
    } catch (e) {
      // swallow to still allow navigation back, but log for debugging
      // eslint-disable-next-line no-console
      console.error('BackButton onBeforeNavigate failed:', e);
    }
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      disabled={disabled}
      onClick={handleClick}
      className={`flex-row flex items-center justify-center bg-buttonColorActive text-white font-semibold w-32 p-3 rounded-md self-center disabled:bg-gray-300 disabled:text-gray-500 disabled:border-gray-300 disabled:cursor-not-allowed hover:bg-customeOrange hover:text-customeBlack ${className || ''}`}
    >
  {icon ? icon : <MdOutlineChevronLeft className="mr-6" fontSize={24} />}
  {label || 'Back'}
    </button>
  );
}

export default BackButton;
